// Ablagefeld fuer das unterschriebene Dokumentenpaket (PDF, JPG, PNG):
// hineinziehen oder anklicken. Geprueft wird erst beim Hinzufuegen - hier wird
// nur angezeigt, was gewaehlt ist, und ob es passt.

import React, { useRef, useState } from 'react';
import { FileCheck2, Upload, X as XIcon } from 'lucide-react';
import { T, knopfStil } from '../../../lib/designTokens';
import { DATEI_ANNAHME, groesseText, pruefeDatei } from '../../../lib/dokumentenAssistent';

export default function DateiFeld({ datei, onWahl, gesperrt = false }) {
  const eingabe = useRef(null);
  const [ziehtDrueber, setZiehtDrueber] = useState(false);
  const problem = datei ? pruefeDatei(datei) : '';

  const oeffnen = () => {
    if (!gesperrt) eingabe.current?.click();
  };
  const ueber = (ereignis, an) => {
    ereignis.preventDefault();
    ereignis.stopPropagation();
    if (!gesperrt) setZiehtDrueber(an);
  };
  const ablegen = (ereignis) => {
    ueber(ereignis, false);
    const gewaehlt = ereignis.dataTransfer?.files?.[0];
    if (gewaehlt && !gesperrt) onWahl(gewaehlt);
  };
  const gewaehlt = (ereignis) => {
    const neu = ereignis.target.files?.[0];
    ereignis.target.value = '';
    if (neu) onWahl(neu);
  };

  const randFarbe = problem ? T.gefahrRand : (ziehtDrueber ? T.orange : T.randStark);
  return (
    <div style={{ display: 'grid', gap: 6 }}>
      <input ref={eingabe} type="file" accept={DATEI_ANNAHME} onChange={gewaehlt} style={{ display: 'none' }} />
      <div
        role="button"
        tabIndex={gesperrt ? -1 : 0}
        aria-disabled={gesperrt}
        aria-label={datei ? `Gewählte Datei ${datei.name} – klicken zum Ändern` : 'Datei wählen oder hierher ziehen'}
        onClick={oeffnen}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); oeffnen(); } }}
        onDragEnter={(e) => ueber(e, true)}
        onDragOver={(e) => ueber(e, true)}
        onDragLeave={(e) => ueber(e, false)}
        onDrop={ablegen}
        style={{
          border: `1.5px dashed ${randFarbe}`, borderRadius: T.rKarte, padding: '22px 16px',
          background: ziehtDrueber ? '#FFF7EE' : T.grund, cursor: gesperrt ? 'not-allowed' : 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, textAlign: 'left',
          opacity: gesperrt ? 0.6 : 1, transition: 'border-color 120ms, background 120ms',
        }}
      >
        {datei ? (
          <>
            <FileCheck2 size={22} color={problem ? T.gefahr : T.navy} />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: T.tText, fontWeight: 700, color: T.ink, wordBreak: 'break-all' }}>{datei.name}</div>
              <div style={{ fontSize: T.tMikro, color: T.muted }}>{groesseText(datei.size)} · klicken zum Ändern</div>
            </div>
          </>
        ) : (
          <>
            <Upload size={22} color={T.muted} />
            <div>
              <div style={{ fontSize: T.tText, fontWeight: 600, color: T.body }}>
                Datei hierher ziehen oder <span style={{ color: T.orangeTinte, fontWeight: 700 }}>auswählen</span>
              </div>
              <div style={{ fontSize: T.tMikro, color: T.muted }}>PDF, JPG oder PNG · höchstens 80 MB</div>
            </div>
          </>
        )}
      </div>
      {datei ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          {problem ? <span style={{ fontSize: T.tMikro, color: T.gefahr, fontWeight: 600 }}>{problem}</span> : null}
          <button type="button" onClick={() => onWahl(null)} disabled={gesperrt}
            style={{ ...knopfStil(false), padding: '4px 8px', marginLeft: 'auto' }}>
            <XIcon size={11} /> Datei entfernen
          </button>
        </div>
      ) : null}
    </div>
  );
}
